import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router';
import MainImage from '../assets/images/res-main-img.png';
import BackImage from '../assets/images/arrow-right.png';
import DropImage from '../assets/images/drop.png';
import ChartImage from '../assets/images/chart.png';
import GrainImage from '../assets/images/grain.png';
import SunImage from '../assets/images/sun.png';
import Loading from '../utils/Loading';
import { toast } from 'react-toastify';

const Result = () => {
    const { id } = useParams();
    const [plantData, setPlantData] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPlantData = async () => {
            try {
                const response = await axios.get(`https://app.golet.app/golet/api/v1/website/front/get-plant/${id}`);
                setPlantData(response.data);
            } catch (error) {
                toast.error(error.response.data.error, { autoClose: 15000 });

            } finally {
                setLoading(false);
            }
        };

        fetchPlantData();
    }, [id]);

    if (loading) {
        return <Loading />;
    }

    if (!plantData) {
        return <div className='text-center mt-20'>اطلاعاتی برای نمایش وجود ندارد</div>;
    }

    const { plantInfo, gallery } = plantData;
    const {
        title,
        image,
        toxic,
        brief_description,
        native_region,
        science_name,
        water_period,
        hardship_level,
        fertilizer,
        lighting
    } = plantInfo;

    const hardshipLevelText = hardship_level === 'easy' ? 'آسان' : hardship_level === 'medium' ? 'متوسط' : hardship_level === 'high' ? 'سخت' : '';
    const lightingText = lighting > 10 ? 'زیاد' : lighting >= 7 ? 'متوسط' : 'کم';


    return (
        <div className='mx-auto max-480'>
            <div className='d-flex align-items-center back-nav'>
                <div className='d-flex fw-600 pointer' onClick={() => navigate(-1)}>
                    <img src={BackImage} alt='Back Img' className='ml-20' />
                    بازگشت
                </div>
            </div>

            

            <div className="res-container mt-16">
                <div className='d-flex justify-content-center mb-8'>
                    <img src={`https://app.golet.app/golet/${image}`} alt='Main Img' className='img-main' />
                </div>

                <div className='d-flex justify-content-center'>
                    {gallery.map((img, index) => (
                        <img key={index} src={`https://app.golet.app/golet/${img.address}`} alt={`Gallery Img ${index}`} className='img-gallary ml-20' />
                    ))}
                </div>
            </div>

            <div className="res-container mt-12 mb-16 mt-16">
                <div className="d-flex justify-content-space-between align-items-center">
                    <div className="d-flex">
                        <div className="fs-20 fw-600 black-text">{title}</div>
                        <div className="badge-yellow yellow-text fw-600 mr-8">{toxic}</div>
                    </div>
                    <div className="green-text fw-600">نحوه تکثیر</div>
                </div>
                <div className="fs-14 line-height-30 gray-text fw-500 mt-16">
                    {brief_description}
                </div>
            </div>

            <div className='about-plant mb-16'>
                <div className="res-container mt-16">
                    <div className="fs-16 fw-600 title-about">درباره گیاه</div>
                    <div className="d-flex align-items-center mt-4">
                        <div className="fw-600 q-plant">بومی منطقه</div>
                        <div className="answer-plant fw-500 mr-8 gray-text fs-12">{native_region}</div>
                    </div>
                    <div className="d-flex align-items-center mt-4">
                        <div className="fw-600 q-plant">نام علمی</div>
                        <div className="answer-plant fw-500 mr-8 gray-text fs-12">{science_name}</div>
                    </div>
                </div>
            </div>


            <div className='res-container relative info mb-16'>
                <div className='overlay'></div>
                <div className='d-flex justify-content-space-between mb-8'>
                    <div className='box'>
                        <div className='d-flex p-4'>
                            <div className='d-flex flex-direction-coulmn align-items-center justify-content-center item watering'>
                                <img src={DropImage} alt='Drop Img' className='mb-8' />
                                <div className='fs-10 fw-600'>آبیاری</div>
                            </div>
                            <div className='d-flex flex-direction-coulmn justify-content-center'>
                                <div className='fs-16 fw-500 mr-8'>هر {water_period} روز</div>
                                <div className='fs-10 gray-text mr-8'>درصورت خشک بودن خاک</div>
                            </div>
                        </div>
                    </div>
                    <div className='box'>
                        <div className='d-flex p-4'>
                            <div className='d-flex flex-direction-coulmn align-items-center justify-content-center item harding'>
                                <img src={ChartImage} alt='Chart Img' className='mb-8' />
                                <div className='fs-10 fw-600'>سختی نگهداری</div>
                            </div>
                            <div className='d-flex flex-direction-coulmn justify-content-center'>
                                <div className='fs-16 fw-500 mr-8'>{hardshipLevelText}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 
                <div className='d-flex justify-content-space-between'>
                    <div className='box'>
                        <div className='d-flex p-4'>
                            <div className='d-flex flex-direction-coulmn align-items-center justify-content-center item fertilizer'>
                                <img src={GrainImage} alt='Grain Img' className='mb-8' />
                                <div className='fs-10 fw-600'>کود دهی</div>
                            </div>
                            <div className='d-flex flex-direction-coulmn justify-content-center'>
                                <div className='fs-16 fw-500 mr-8'>هر {fertilizer} روز</div>
                                <div className='fs-10 gray-text mr-8'> بهار، پاییز و زمستان</div>
                            </div>
                        </div>
                    </div>
                    <div className='box'>
                        <div className='d-flex p-4'>
                            <div className='d-flex flex-direction-coulmn align-items-center justify-content-center item lighting'>
                                <img src={SunImage} alt='Sun Img' className='mb-8' />
                                <div className='fs-10 fw-600'>نیاز نوری</div>
                            </div>
                            <div className='d-flex flex-direction-coulmn justify-content-center'>
                                <div className='fs-16 fw-500 mr-8'>{lightingText}</div>
                                <div className='fs-10 gray-text mr-8'>روزی {lighting} ساعت</div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* <div className='about-plant greenhouse mb-16'>
                <div className="res-container mt-16">
                    <div className="fs-16 fw-600 b-green-text mb-8">گلخانه من</div>
                    <div className='about-greenhouse mb-8'>
                        با نصب برنامه گُلت بر روی تلفن همراه، زمان های آبیاری و کودهی بهت یادآوری میشه و نیازی به یادداشت کردن زمان های آبیاری و کودهی نداری
                    </div>
                    <button className='greenhouse-btn bg-button-green fs-14 fw-600 mb-16'>نصب از کافه بازار</button>
                </div>
            </div> */}

            <div className='bg-white border-0' style={{ marginTop: "-17px" }}>
                <div className="res-container app-not mt-16 mb-16">
                    <div className='fs-16 fw-600 text-align-center mb-25'>
                        به سقف مجاز شناسایی رسیده‌اید، با نصب اپلیکیشن گُلت علاوه بر شناسایی بی‌نهایت می‌توانید:
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex align-items-center mb-12'>
                            <div><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked disabled /></div>
                            <label htmlFor="vehicle1" className='mr-8'>بی‌نهایت شناسایی گل و گیاه</label>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex align-items-center mb-12'>
                            <div><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked disabled /></div>
                            <label htmlFor="vehicle1" className='line-32 mr-8'>دریافت اعلان برای زمان های آبیاری و کودهی گل و گیاه</label>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex align-items-center mb-12'>
                            <div><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked disabled /></div>
                            <div htmlFor="vehicle1" className='line-32 mr-8'>پیشنهاد گل و گیاه با در نظر گرفتن شرایط محل زندگی و مهارت شما</div>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex align-items-center mb-12'>
                            <div><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked disabled /></div>
                            <div htmlFor="vehicle1" className='mr-8'>آموزش تکثیر گل و گیاه</div>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex align-items-center mb-12'>
                            <div><input type="checkbox" id="vehicle1" name="vehicle1" value="Bike" checked disabled /></div>
                            <label htmlFor="vehicle1" className='line-32 mr-8'>+100 مقاله آموزشی در حوزه نگهداری گل و گیاه</label>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <button className='bg-button-green app-not-btn pointer fs-14 fw-600 mb-16' onClick={() => window.location.href = "https://cafebazaar.ir/app/app.golet.app"}
                        >نصب از کافه بازار</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Result;
